module.exports = __webpack_public_path__ + "static/media/wowme.87003a56.svg";